import { useLang } from "hooks/useLang"

const EventScheduleComponent = ({
    dayNumber,
    dayName,
}: { dayNumber: string; dayName: string }) => {
    const { t } = useLang()

    return (
        <div
            className="flex items-center min-w-[250px] justify-center  h-[110px] rounded-[10px] dark:border-[#FFFFFF80]
         border-[#B5B5B5] border-[2px] flex-row"
        >
            <div className="flex flex-col items-center justify-center  h-full  px-2">
                <span className="text-[34px]">{dayNumber}</span>
                <span className="capitalize text-[16px]">{t("April")}</span>
            </div>
            <div className="w-[2px] h-[50%] bg-black dark:bg-[#FFFFFF80] rounded-[2px]" />
            <div className="flex flex-col items-start justify-center h-full px-5">
                <span className="text-[26px] capitalize">{t(dayName)}</span>
                <span className=" text-[14px]">{`03:00 ${t("PM")} ${t("to")} 11:00 ${t("PM")}`}</span>
            </div>
        </div>
    )
}

export default EventScheduleComponent
